class AuthenticityModalOpener extends HTMLElement {
  constructor() {
    super();
    this.handleOpen = this.handleOpen.bind(this);
  }

  connectedCallback() {
    this.trigger = this.querySelector("button");
    this.trigger?.addEventListener("click", this.handleOpen);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener("click", this.handleOpen);
  }

  handleOpen() {
    const modal = document.querySelector(this.dataset.modal);
    if (!modal || typeof modal.show !== "function") return;

    const triggerBounds = this.trigger.getBoundingClientRect();
    modal.style.setProperty(
      "--authenticity-popover-top",
      `${triggerBounds.bottom + 12}px`,
    );
    modal.style.setProperty(
      "--authenticity-popover-right",
      `${Math.max(16, window.innerWidth - triggerBounds.right)}px`,
    );
    modal.show(this.trigger);
  }
}

class AuthenticityLearnMore extends HTMLElement {
  constructor() {
    super();
    this.handleOpen = this.handleOpen.bind(this);
  }

  connectedCallback() {
    this.trigger = this.querySelector("button");
    this.trigger?.addEventListener("click", this.handleOpen);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener("click", this.handleOpen);
  }

  handleOpen() {
    const popover = this.closest("modal-dialog");
    const modal = document.querySelector(this.dataset.modal);
    const returnFocusTarget = document.getElementById(this.dataset.returnFocus);

    if (!modal || typeof modal.show !== "function") return;

    popover?.hide();
    modal.show(returnFocusTarget || this.trigger);
  }
}

if (!customElements.get("authenticity-modal-opener")) {
  customElements.define("authenticity-modal-opener", AuthenticityModalOpener);
}

if (!customElements.get("authenticity-learn-more")) {
  customElements.define("authenticity-learn-more", AuthenticityLearnMore);
}
